import styled, { css } from 'styled-components';
import { Theme, baseContainer } from '@redsift/design-system';
import { ToggletipPlacement } from '../toggletip';
import { StyledToggletipContentProps } from './types';

/**
 * Component style.
 */
export const StyledToggletipContent = styled.div<StyledToggletipContentProps>`
  ${baseContainer}
  ${({ $theme }) => css`
    color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
    background-color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'black' : 'white'});
  `}

  align-items: center;
  border-radius: 4px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  display: flex;
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12));
  font-family: var(--redsift-typography-toggletip-font-family);
  font-size: var(--redsift-typography-toggletip-font-size);
  font-weight: var(--redsift-typography-toggletip-font-weight);
  line-height: var(--redsift-typography-toggletip-line-height);
  max-width: calc(100vw - 48px);
  padding: 4px 8px;
  z-index: var(--redsift-layout-z-index-toggletip);

  .redsift-toggletip-content__arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: ${({ $theme }) =>
      $theme === Theme.dark ? css`var(--redsift-color-neutral-black)` : css`var(--redsift-color-neutral-white)`};
    border-style: solid;
  }

  ${({ $placement }) => {
    switch ($placement) {
      case ToggletipPlacement['right-start']:
        return css`
          border-bottom-left-radius: 0;
        `;
      case ToggletipPlacement['right-end']:
        return css`
          border-top-left-radius: 0;
        `;
      case ToggletipPlacement['left-start']:
        return css`
          border-bottom-right-radius: 0;
        `;
      case ToggletipPlacement['left-end']:
        return css`
          border-top-right-radius: 0;
        `;
      default:
        return css``;
    }
  }}

  ${({ $placement }) => {
    switch ($placement) {
      case ToggletipPlacement.left:
      case ToggletipPlacement['left-end']:
      case ToggletipPlacement['left-start']:
        return css`
          .redsift-toggletip-content__arrow {
            border-width: 6px 0 6px 6px;
            border-top-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
          }
        `;
      case ToggletipPlacement.top:
      case ToggletipPlacement['top-end']:
      case ToggletipPlacement['top-start']:
        return css`
          .redsift-toggletip-content__arrow {
            border-width: 6px 6px 0;
            border-right-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        `;
      case ToggletipPlacement.right:
      case ToggletipPlacement['right-end']:
      case ToggletipPlacement['right-start']:
        return css`
          .redsift-toggletip-content__arrow {
            border-width: 6px 6px 6px 0;
            border-top-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        `;
      case ToggletipPlacement.bottom:
      case ToggletipPlacement['bottom-end']:
      case ToggletipPlacement['bottom-start']:
      default:
        return css`
          .redsift-toggletip-content__arrow {
            border-width: 0 6px 6px;
            border-top-color: transparent;
            border-right-color: transparent;
            border-left-color: transparent;
          }
        `;
    }
  }}
`;
